import TextInput from './TextInput'

export default TextInput



// WEBPACK FOOTER //
// ./src/app/elements/TextInput/index.js